import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-508c042d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "evaluate"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-star-light" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "textLink"
}
const _hoisted_12 = {
  key: 0,
  style: {"color":"#999999"}
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  style: {"display":"flex","justify-content":"center","margin":"5px 0 5px 0"}
}
const _hoisted_15 = {
  key: 1,
  style: {"display":"flex","font-size":"14px","margin":"5px 0 5px 0"}
}
const _hoisted_16 = {
  key: 0,
  style: {"color":"#999999"}
}
const _hoisted_17 = {
  key: 1,
  style: {"color":"#D9001B"}
}
const _hoisted_18 = {
  key: 2,
  style: {"color":"#67C23A"}
}
const _hoisted_19 = {
  key: 3,
  style: {"color":"#67C23A"}
}
const _hoisted_20 = {
  key: 2,
  style: {"display":"flex","font-size":"14px","margin":"5px 0 5px 0"}
}
const _hoisted_21 = {
  key: 0,
  style: {"color":"#67C23A"}
}
const _hoisted_22 = {
  key: 1,
  style: {"color":"#67C23A"}
}
const _hoisted_23 = {
  key: 2,
  style: {"color":"#D9001B"}
}
const _hoisted_24 = {
  key: 1,
  class: "textLink"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { style: {"text-align":"center","margin-bottom":"10px"} }
const _hoisted_27 = {
  key: 0,
  style: {"font-size":"14px","color":"#333333","line-height":"26px"}
}
const _hoisted_28 = {
  key: 1,
  style: {"font-size":"14px","color":"#333333","line-height":"26px"}
}
const _hoisted_29 = {
  key: 2,
  style: {"display":"flex","justify-content":"center","margin":"5px 0 5px 0"}
}
const _hoisted_30 = {
  key: 3,
  style: {"display":"flex","font-size":"14px","margin":"5px 0 5px 0"}
}
const _hoisted_31 = {
  key: 0,
  style: {"color":"#D9001B"}
}
const _hoisted_32 = {
  key: 1,
  style: {"color":"#67C23A"}
}
const _hoisted_33 = {
  key: 4,
  style: {"display":"flex","font-size":"14px","margin":"5px 0 5px 0"}
}
const _hoisted_34 = {
  key: 0,
  style: {"color":"#D9001B"}
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { style: {"line-height":"26px"} }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"26px","color":"#67C23A"} }, "*候选人已同意", -1))
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { style: {"text-align":"center","margin-bottom":"10px"} }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { style: {"line-height":"26px"} }
const _hoisted_42 = {
  key: 0,
  style: {"line-height":"26px"}
}
const _hoisted_43 = {
  key: 2,
  class: "textLink"
}
const _hoisted_44 = {
  key: 0,
  style: {"color":"#999999"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"50px"} }, null, -1))
const _hoisted_46 = { key: 2 }
const _hoisted_47 = {
  key: 0,
  style: {"display":"flex","justify-content":"center","margin":"15px 0 5px 0"}
}
const _hoisted_48 = {
  key: 3,
  style: {"display":"flex","font-size":"14px","margin":"5px 0 5px 0"}
}
const _hoisted_49 = {
  key: 0,
  style: {"color":"#999999"}
}
const _hoisted_50 = {
  key: 1,
  style: {"color":"#D9001B"}
}
const _hoisted_51 = {
  key: 2,
  style: {"color":"#67C23A"}
}
const _hoisted_52 = {
  key: 4,
  style: {"display":"flex","font-size":"14px","margin":"5px 0 5px 0"}
}
const _hoisted_53 = {
  key: 0,
  style: {"color":"#67C23A"}
}
const _hoisted_54 = {
  key: 1,
  style: {"color":"#D9001B"}
}
const _hoisted_55 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isCustom === _ctx.constant.typeService)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", null, [
            _createElementVNode("label", null, _toDisplayString(_ctx.extension.title), 1),
            (_ctx.extension.hyperlinks_text)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.extension.hyperlinks_text.value,
                  target: "view_window"
                }, _toDisplayString(_ctx.extension.hyperlinks_text.key), 9, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          (_ctx.extension.item && _ctx.extension.item.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extension.item, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    (_ctx.isUrl(item.value))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: item.value,
                          target: "view_window"
                        }, _toDisplayString(item.key), 9, _hoisted_5))
                      : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(item.key), 1))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("article", null, _toDisplayString(_ctx.extension.description), 1)
        ]))
      : (_ctx.isCustom.businessID === _ctx.constant.typeEvaluate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('message.custom.对本次服务评价')), 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(~~_ctx.isCustom.score, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "evaluate-list-item",
                  key: index
                }, _hoisted_9))
              }), 128))
            ]),
            _createElementVNode("article", null, _toDisplayString(_ctx.isCustom.comment), 1)
          ]))
        : (_ctx.isCustom.businessID === _ctx.constant.typeOrder)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "order",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openLink(_ctx.isCustom.link)))
            }, [
              _createElementVNode("img", {
                src: _ctx.isCustom.imageUrl,
                alt: ""
              }, null, 8, _hoisted_10),
              _createElementVNode("main", null, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.isCustom.title), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.isCustom.description), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.isCustom.price), 1)
              ])
            ]))
          : (_ctx.isCustom.businessID === _ctx.constant.typeTextLink)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                (_ctx.isCustom.linkMsgType != 'contact'&&_ctx.isCustom.linkMsgType != 'entry')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("p", {
                        style: _normalizeStyle([{"text-align":"center","margin-bottom":"10px"}, (_ctx.getStatus(_ctx.isCustom.interview_id)&&_ctx.getStatus(_ctx.isCustom.interview_id)== 8)?'color:#999999':'color:#333333'])
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.isCustom.text) + " ", 1),
                        _createElementVNode("span", null, [
                          (_ctx.getStatus(_ctx.isCustom.interview_id)&&_ctx.getStatus(_ctx.isCustom.interview_id) == 8)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "（已超时）"))
                            : _createCommentVNode("", true)
                        ])
                      ], 4),
                      _createElementVNode("div", {
                        style: _normalizeStyle([{"font-size":"14px","color":"#333333","line-height":"26px"}, (_ctx.getStatus(_ctx.isCustom.interview_id)&&_ctx.getStatus(_ctx.isCustom.interview_id)== 8)?'color:#999999':'color:#333333'])
                      }, _toDisplayString(_ctx.isCustom.content), 5),
                      _createElementVNode("div", {
                        style: _normalizeStyle([{"font-size":"14px","color":"#333333","line-height":"26px"}, (_ctx.getStatus(_ctx.isCustom.interview_id)&&_ctx.getStatus(_ctx.isCustom.interview_id)== 8)?'color:#999999':'color:#333333'])
                      }, [
                        _createTextVNode(" 面试时间 : "),
                        _createElementVNode("span", null, _toDisplayString(_ctx.isCustom.time), 1)
                      ], 4),
                      (_ctx.getStatus(_ctx.isCustom.interview_id)&&(_ctx.getStatus(_ctx.isCustom.interview_id) != 6&&_ctx.getStatus(_ctx.isCustom.interview_id) != 7&&_ctx.getStatus(_ctx.isCustom.interview_id) != 8&&_ctx.getStatus(_ctx.isCustom.interview_id) != 2))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_ctx.touid == _ctx.isCustom.myuid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createElementVNode("div", null, [
                                    (_ctx.getStatus(_ctx.isCustom.interview_id)&&_ctx.getStatus(_ctx.isCustom.interview_id) == 1)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          style: {"width":"70px","height":"26px","display":"flex","align-items":"center","justify-content":"center","color":"#333","background":"#F2F6FC","border-radius":"4px","margin-right":"40px","border":"1px solid #909399","cursor":"pointer"},
                                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refuse(_ctx.isCustom.interview_id)))
                                        }, "拒绝"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", null, [
                                    (_ctx.getStatus(_ctx.isCustom.interview_id)&&_ctx.getStatus(_ctx.isCustom.interview_id) == 1 )
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          style: {"width":"70px","height":"28px","display":"flex","align-items":"center","justify-content":"center","color":"#fff","background":"rgba(0, 110, 255, 1)","border-radius":"4px","margin-right":"15px","cursor":"pointer"},
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.accept(_ctx.isCustom.interview_id)))
                                        }, "接受"))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.myuid == _ctx.isCustom.myuid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            (_ctx.getStatus(_ctx.isCustom.interview_id)&&_ctx.getStatus(_ctx.isCustom.interview_id) == 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, "*等待候选人确认"))
                              : _createCommentVNode("", true),
                            (_ctx.getStatus(_ctx.isCustom.interview_id)&&_ctx.getStatus(_ctx.isCustom.interview_id) == 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, "*候选人已拒绝"))
                              : _createCommentVNode("", true),
                            (_ctx.getStatus(_ctx.isCustom.interview_id)&&(_ctx.getStatus(_ctx.isCustom.interview_id) == 3 || _ctx.getStatus(_ctx.isCustom.interview_id) == 4 || _ctx.getStatus(_ctx.isCustom.interview_id) == 5 || _ctx.getStatus(_ctx.isCustom.interview_id) == 7))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, " *候选人已接受邀请"))
                              : _createCommentVNode("", true),
                            (_ctx.getStatus(_ctx.isCustom.interview_id)&&_ctx.getStatus(_ctx.isCustom.interview_id) > 5)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, "*面试结束"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.touid == _ctx.isCustom.myuid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (_ctx.getStatus(_ctx.isCustom.interview_id)&&(_ctx.getStatus(_ctx.isCustom.interview_id) == 3 || _ctx.getStatus(_ctx.isCustom.interview_id) == 4 || _ctx.getStatus(_ctx.isCustom.interview_id) == 5 || _ctx.getStatus(_ctx.isCustom.interview_id) == 7))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, " *已接受"))
                              : _createCommentVNode("", true),
                            (_ctx.getStatus(_ctx.isCustom.interview_id)&&(_ctx.getStatus(_ctx.isCustom.interview_id) > 5))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, "*面试结束"))
                              : _createCommentVNode("", true),
                            (_ctx.getStatus(_ctx.isCustom.interview_id)&&_ctx.getStatus(_ctx.isCustom.interview_id) == 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, "*已拒绝"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isCustom.linkMsgType == 'contact')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      (_ctx.isCustom.isReplay == '2')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.isCustom.text), 1),
                            (_ctx.touid == _ctx.isCustom.myuid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.isCustom.content), 1))
                              : _createCommentVNode("", true),
                            (_ctx.myuid == _ctx.isCustom.myuid&&_ctx.getPhoneStatus(_ctx.isCustom.applyId)&&_ctx.getPhoneStatus(_ctx.isCustom.applyId).status != 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, " 正在请求获取" + _toDisplayString(_ctx.isCustom.tonickname) + "的联系方式，请等候对方确认", 1))
                              : _createCommentVNode("", true),
                            (_ctx.touid == _ctx.isCustom.myuid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _createElementVNode("div", null, [
                                    (_ctx.getPhoneStatus(_ctx.isCustom.applyId)&&_ctx.getPhoneStatus(_ctx.isCustom.applyId).status != 2&&_ctx.getPhoneStatus(_ctx.isCustom.applyId).status != 1)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refuseGivePhone(_ctx.isCustom.applyId))),
                                          style: {"width":"70px","height":"26px","display":"flex","align-items":"center","justify-content":"center","color":"#333","background":"#F2F6FC","border-radius":"4px","margin-right":"40px","border":"1px solid #909399","cursor":"pointer"}
                                        }, " 拒绝"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", null, [
                                    (_ctx.getPhoneStatus(_ctx.isCustom.applyId)&&_ctx.getPhoneStatus(_ctx.isCustom.applyId).status != 2&&_ctx.getPhoneStatus(_ctx.isCustom.applyId).status != 1)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.agreeGivePhone(_ctx.isCustom.applyId))),
                                          style: {"width":"70px","height":"28px","display":"flex","align-items":"center","justify-content":"center","color":"#fff","background":"rgba(0, 110, 255, 1)","border-radius":"4px","margin-right":"15px","cursor":"pointer"}
                                        }, " 同意"))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.touid == _ctx.isCustom.myuid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  (_ctx.getPhoneStatus(_ctx.isCustom.applyId)&&_ctx.getPhoneStatus(_ctx.isCustom.applyId).status == 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, "*已拒绝 "))
                                    : _createCommentVNode("", true),
                                  (_ctx.getPhoneStatus(_ctx.isCustom.applyId)&&_ctx.getPhoneStatus(_ctx.isCustom.applyId).status == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, "*已同意 "))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.myuid == _ctx.isCustom.myuid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  (_ctx.getPhoneStatus(_ctx.isCustom.applyId)&&_ctx.getPhoneStatus(_ctx.isCustom.applyId)?.status == 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, "*候选人已拒绝"))
                                    : _createCommentVNode("", true),
                                  (_ctx.getPhoneStatus(_ctx.isCustom.applyId)&&_ctx.getPhoneStatus(_ctx.isCustom.applyId)?.status == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                        _createElementVNode("div", _hoisted_36, "正在请求获取" + _toDisplayString(_ctx.isCustom.tonickname) + "的联系方式，请等候对方确认", 1),
                                        _hoisted_37
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isCustom.isReplay == '1')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.isCustom.text), 1),
                            (_ctx.getPhoneStatus(_ctx.isCustom.applyId)&&_ctx.getPhoneStatus(_ctx.isCustom.applyId)?.status == 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.isCustom.tonickname) + "的联系方式", 1),
                                  (_ctx.getPhoneStatus(_ctx.isCustom.applyId))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, " 手机号：" + _toDisplayString(_ctx.getPhoneStatus(_ctx.isCustom.applyId).user_data.mobile), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isCustom.linkMsgType == 'entry')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("p", {
                        style: _normalizeStyle([{"text-align":"center","margin-bottom":"10px"}, (_ctx.getEntryStatus(_ctx.isCustom.applyId)&&_ctx.getEntryStatus(_ctx.isCustom.applyId) == 6)?'color:#999999':'color:#333333'])
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.isCustom.text) + " ", 1),
                        _createElementVNode("span", null, [
                          (_ctx.getEntryStatus(_ctx.isCustom.applyId)&&_ctx.getEntryStatus(_ctx.isCustom.applyId) == 6)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, "（已超时）"))
                            : _createCommentVNode("", true)
                        ])
                      ], 4),
                      _createElementVNode("div", {
                        style: _normalizeStyle([{"font-size":"14px","color":"#333333","line-height":"26px","display":"flex"}, (_ctx.getEntryStatus(_ctx.isCustom.applyId)&&_ctx.getEntryStatus(_ctx.isCustom.applyId) == 6)?'color:#999999':'color:#333333'])
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.companyInfo.title) + "正在邀请您加入", 1),
                        _hoisted_45
                      ], 4),
                      (_ctx.myuid == _ctx.isCustom.myuid)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: _normalizeStyle([{"font-size":"14px","color":"#333333","line-height":"26px"}, (_ctx.getEntryStatus(_ctx.isCustom.applyId)&&_ctx.getEntryStatus(_ctx.isCustom.applyId) == 6)?'color:#999999':'color:#333333'])
                          }, _toDisplayString(_ctx.isCustom.tonickname) + "将入职" + _toDisplayString(_ctx.isCustom.structure), 5))
                        : _createCommentVNode("", true),
                      (_ctx.touid == _ctx.isCustom.myuid)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: _normalizeStyle([{"font-size":"14px","color":"#333333","line-height":"26px"}, (_ctx.getEntryStatus(_ctx.isCustom.applyId)&&_ctx.getEntryStatus(_ctx.isCustom.applyId) == 6)?'color:#999999':'color:#333333'])
                          }, "入职" + _toDisplayString(_ctx.isCustom.structure), 5))
                        : _createCommentVNode("", true),
                      (_ctx.getEntryStatus(_ctx.isCustom.applyId)&&_ctx.getEntryStatus(_ctx.isCustom.applyId) == 4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            (_ctx.touid == _ctx.isCustom.myuid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", {
                                      style: {"width":"70px","height":"22px","display":"flex","align-items":"center","justify-content":"center","color":"#333","background":"#F2F6FC","border-radius":"4px","margin-right":"20px","border":"1px solid #909399","cursor":"pointer"},
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.refuseEntry(_ctx.isCustom.applyId)))
                                    }, "拒绝")
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", {
                                      style: {"width":"70px","height":"24px","display":"flex","align-items":"center","justify-content":"center","color":"#fff","background":"rgba(0, 110, 255, 1)","border-radius":"4px","margin-right":"15px","cursor":"pointer"},
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.agreeEntry(_ctx.isCustom.applyId)))
                                    }, "接受")
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.myuid == _ctx.isCustom.myuid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            (_ctx.getEntryStatus(_ctx.isCustom.applyId)&&_ctx.getEntryStatus(_ctx.isCustom.applyId) == 4)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, "*等待候选人确认"))
                              : _createCommentVNode("", true),
                            (_ctx.getEntryStatus(_ctx.isCustom.applyId)&&_ctx.getEntryStatus(_ctx.isCustom.applyId) == 5)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_50, "*候选人已拒绝"))
                              : _createCommentVNode("", true),
                            (_ctx.getEntryStatus(_ctx.isCustom.applyId)&&_ctx.getEntryStatus(_ctx.isCustom.applyId) == 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_51, "*候选人已接受"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.touid == _ctx.isCustom.myuid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            (_ctx.getEntryStatus(_ctx.isCustom.applyId)&&_ctx.getEntryStatus(_ctx.isCustom.applyId) == 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, "*已接受"))
                              : _createCommentVNode("", true),
                            (_ctx.getEntryStatus(_ctx.isCustom.applyId)&&_ctx.getEntryStatus(_ctx.isCustom.applyId) == 5)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_54, "*已拒绝"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_ctx.isCustom.businessID === _ctx.constant.TYPE_CALL_MESSAGE)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: _normalizeClass(["call", `call-${_ctx.data?.message?.conversationType}`]),
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleCallAgain && _ctx.handleCallAgain(...args)))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["icon", _ctx.handleCallMessageIcon()])
                  }, null, 2),
                  _createElementVNode("span", null, _toDisplayString(_ctx.data.custom), 1)
                ], 2))
              : (_openBlock(), _createElementBlock("span", {
                  key: 5,
                  innerHTML: _ctx.data.custom
                }, null, 8, _hoisted_55))
  ]))
}